/**
 * @module components\ghModelView\propView\templates\textArea
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "./../../base";

@Component
export default class TextArea extends Base {}
